export default "__VITE_ASSET__CU4nQrzY__"